import { jsx as c, jsxs as K } from "react/jsx-runtime";
import { useLink as be } from "@made-people/grease-link";
import { createEventEmitter as me } from "@made-people/grease-event-emitter";
import { createContext as l, useContext as u, useMemo as m, useRef as y, useEffect as g, useReducer as N, useCallback as ve } from "react";
import { z as r } from "zod";
import { moneySchema as f } from "@made-people/grease-money";
import { withZod as L } from "@made-people/react-prop-guard";
import { useSeenInViewport as fe } from "@made-people/react-use-seen-in-viewport";
import { overlayEventEmitter as Pe } from "@made-people/blueprint-overlay";
const E = me(), G = l(void 0), Dt = (e) => /* @__PURE__ */ c(G.Provider, { value: e, children: e.children }), ye = () => {
  const e = u(G);
  return e || { additionalData: void 0 };
}, O = r.object({
  attributeLabel: r.string().describe("The localized label of the attribute"),
  attributeKey: r.string().describe("The key of the attribute"),
  // For some reason, z.unknown() makes the field optional
  value: r.custom((e) => typeof e < "u", "Must be set").describe("The value of the attribute"),
  valueLabel: r.string().describe("The localized label of the value")
}).strict(), A = r.object({
  width: r.number().describe("The image width"),
  height: r.number().describe("The image height")
}), ge = r.object({
  type: r.literal("image"),
  src: r.string().describe("The image source"),
  alt: r.string().describe("The image alt text"),
  dimensions: A.optional(),
  attributes: O.array().optional().describe("The image attributes")
}), Se = r.object({
  type: r.literal("video"),
  src: r.string().describe("The video source"),
  poster: r.string().describe("The video poster"),
  dimensions: A.optional(),
  attributes: O.array().optional().describe("The video attributes")
}), Ie = r.discriminatedUnion("type", [
  ge,
  Se
]);
function Te(e) {
  return e.type === "image";
}
const we = r.object({
  label: r.string().describe("The badge label"),
  badgeType: r.string().describe("The badge type, just a simple string"),
  backgroundColor: r.string().optional().describe("The badge background color"),
  textColor: r.string().optional().describe("The badge text color"),
  imageSrc: r.string().optional().describe("The badge image source")
}), Ee = r.object({
  name: r.string().describe("The product name"),
  description: r.string().describe("The product description, can be a long text"),
  shortDescription: r.string().describe("The product short description"),
  media: Ie.array().describe("The product media (images, videos, etc)"),
  badges: we.array(),
  specifications: r.record(
    r.string().describe("The group ID of the specifications"),
    r.array(
      r.object({
        label: r.string(),
        value: r.string(),
        icon: r.custom(() => !0).optional()
      })
    )
  ).optional().describe("The product specifications grouped by groupId"),
  brand: r.string().optional().describe("The brand of the product")
}), Oe = r.object({
  categoryId: r.string(),
  slug: r.string(),
  name: r.string()
}), P = r.object({
  productId: r.string().describe("The product ID (could be a database ID)"),
  productKey: r.string().describe("The product business key or ID, sometimes called 'model ID"),
  slug: r.string().describe("The slug part of a product URL"),
  discontinued: r.boolean().describe("Whether the product is discontinued"),
  content: Ee.describe("All localizable product content"),
  attributes: O.array().describe(
    "The remaining list of product attributes that don't have a place in the required information above"
  ),
  categories: Oe.array().describe("The product categories")
}), De = P, D = r.object({
  base: P,
  siblingProducts: De.array()
}), w = r.object({
  quantity: r.number().describe("The stock quantity"),
  inStock: r.boolean().describe("Whether the item is in stock"),
  warehouseId: r.string().describe("The warehouse ID, useful when doing omnichannel features")
}), ke = r.object({
  percent: r.number().describe("The discount percentage")
}), R = r.object({
  price: f.describe("The price of the item"),
  priceWithoutDiscount: f.describe(
    "The price of the item without discount"
  )
}), Ve = R.merge(
  r.object({
    periodDays: r.number().describe(
      "The period in days for which this was the lowest price (e.g., 30, 60, 90 days)"
    ).optional(),
    date: r.date().describe("The date when the price was as defined in this object")
  })
), _ = R.merge(
  r.object({
    discountInfo: ke.optional().describe(
      "The discount information and original price in case of a discount"
    ),
    previouslyDiscountedPrices: Ve.array().describe("Sorted list of previously discounted prices"),
    discountButNoCampaign: r.boolean().optional().describe(
      "When true, the product has a discounted price but is not part of an active sale campaign. Strikethrough pricing remains visible but sale indicators are suppressed."
    )
  })
), k = r.object({
  sku: r.string().describe(
    "The SKU (Stock Keeping Unit), aka the identifier used by the warehouse to locate the product"
  ),
  inventory: w.describe(
    "The main  consumer facing stock information"
  ),
  additionalInventory: w.array().describe(
    "Additional inventory information, such as stock in other warehouses or physical stores"
  ),
  priceInfo: _.describe("The price information")
}), z = k.merge(
  D.extend({
    dataModel: r.literal("simple"),
    itemId: r.string().describe("The item ID of this product, used for add to cart requests"),
    ean: r.string().optional().describe("The EAN (European Article Number) barcode"),
    outOfStockItemId: r.string().optional().describe(
      "The id that should be used for sending out of stock events, if not added, itemId will be used"
    ),
    isBundle: r.boolean().describe("Whether this product is a bundle")
  })
), xe = r.object({
  /**
   * The dimension key
   *
   * @example "color" | "size"
   */
  dimensionKey: r.string(),
  /**
   * The translated label or "name" of the dimension
   *
   * @example "Color" | "Färg" | "Size" | "Storlek"
   */
  dimensionLabel: r.string(),
  /**
   * The value of the dimension
   *
   * @example "blue" | "red" | "small" | "large"
   */
  value: r.string(),
  /**
   * The translated label of the dimension value
   *
   * @example "Blue" | "Röd" | "Small" | "Liten"
   */
  valueLabel: r.string()
}), Ce = k.extend({
  mainProductId: r.string().describe("The main product ID"),
  mainProductKey: r.string().describe("The main product key"),
  variantId: r.string().describe("The ID of this specific variant"),
  variantKey: r.string().describe("The key of this specific variant"),
  ean: r.string().optional().describe("The EAN (European Article Number) barcode of this variant"),
  outOfStockItemId: r.string().optional().describe(
    "The id that should be used for sending out of stock events, if not added, variantId will be used"
  ),
  label: r.string().describe("The localized label of this variant"),
  dimensions: xe.array().describe("The dimensions this variant belongs to")
}), U = D.extend({
  dataModel: r.literal("with_variants"),
  variants: Ce.array().describe(
    "The list of purchasable product variants, listed in for instance size pickers.s"
  )
}), Be = r.object({
  sectionId: r.number(),
  quantity: r.number().describe("The quantity of items in the section"),
  products: r.array(r.union([z, U]))
}), Me = k.extend({
  priceOfItemsOutsideBundle: f.describe(
    "The price of items if bought outside the bundle"
  ),
  discountFromPriceOfItemsOutsideBundle: f.describe(
    "The discount from the price of items if bought outside the bundle"
  ),
  priceMin: f.describe("The minimum price of the bundle"),
  priceMax: f.describe("The maximum price of the bundle")
}), je = D.extend({
  dataModel: r.literal("bundle"),
  preConfiguredBundle: r.boolean().describe(
    "true if the bundle is preConfigured and can't be changed by the customer"
  ),
  bundlePurchaseInfo: Me,
  itemId: r.string().describe("The item ID of this bundle, used for add to cart requests"),
  sections: Be.array()
}), $ = r.discriminatedUnion("dataModel", [
  z,
  U,
  je
]), W = r.object({
  product: $,
  relationType: r.string().describe("The type of relation between the products")
}), Ke = r.object({
  product: $,
  relatedProducts: W.array()
});
function q(e, t) {
  return e.find((n) => Object.entries(t).every(
    ([o, i]) => {
      if (!i)
        return !1;
      const s = n.dimensions.find(
        (a) => a.dimensionKey === o
      );
      return (s == null ? void 0 : s.value) === i.dimensionValue;
    }
  ));
}
function Ne(e, t) {
  var n;
  switch (t.type) {
    case "SET_STATE":
      return { ...e, ...t.payload };
    case "SELECT_OPTION":
      if (!((n = e.optionGroups.find(
        (a) => a.dimensionKey === t.payload.dimensionKey
      )) == null ? void 0 : n.options.some(
        (a) => a.dimensionValue === t.payload.option.dimensionValue
      )))
        return console.error(
          `Option '${t.payload.option.dimensionValue}' does not exist in dimension '${t.payload.dimensionKey}'`
        ), e;
      const i = {
        ...e.selectedOptions,
        [t.payload.dimensionKey]: t.payload.option
      }, s = q(e.variants, i);
      return {
        ...e,
        selectedOptions: i,
        selectedVariant: s || e.selectedVariant
      };
    case "CLEAR_OPTIONS":
      return {
        ...e,
        selectedOptions: {},
        selectedVariant: e.initialProductVariant
      };
    default:
      throw new Error(`Invalid action type '${t == null ? void 0 : t.type}'`);
  }
}
const S = () => {
  const e = u(C);
  if (!e)
    throw new Error(
      "useProductVariant must be used within a ProductVariantProvider"
    );
  return e.selectedVariant;
}, F = () => S().dimensions.map((t) => ({
  dimensionKey: t.dimensionKey,
  dimensionLabel: t.dimensionLabel
})), V = () => {
  const e = u(C);
  if (!e)
    throw new Error(
      "useProductVariantState must be used within a ProductVariantProvider"
    );
  return e;
}, Le = () => {
  const e = u(te);
  if (!e)
    throw new Error(
      "useProductVariantDispatch must be used within a ProductVariantProvider"
    );
  return e;
};
function Ge(e, t, n) {
  return e.map((o) => {
    const i = Object.entries(n).filter(
      ([s, a]) => s !== o.dimensionKey && a !== void 0
    );
    return i.length === 0 ? o : {
      ...o,
      options: o.options.map((s) => {
        const a = t.some((d) => d.dimensions.some(
          (b) => b.dimensionKey === o.dimensionKey && b.value === s.dimensionValue
        ) ? d.inventory.inStock && i.every(
          ([b, p]) => d.dimensions.some(
            (j) => j.dimensionKey === b && j.value === p.dimensionValue
          )
        ) : !1);
        return {
          ...s,
          inventory: {
            ...s.inventory,
            inStock: a
          }
        };
      })
    };
  });
}
const Z = () => {
  const e = V(), t = Le();
  return {
    optionGroups: m(
      () => Ge(
        e.optionGroups,
        e.variants,
        e.selectedOptions
      ),
      [
        e.optionGroups,
        e.variants,
        e.selectedOptions
      ]
    ),
    selectedOptions: e.selectedOptions,
    selectOption: (o, i) => t({
      type: "SELECT_OPTION",
      payload: { dimensionKey: o, option: i }
    }),
    clearOptions: () => t({
      type: "CLEAR_OPTIONS"
    })
  };
}, Ae = () => {
  const e = Z();
  return F().filter(
    ({ dimensionKey: o }) => !e.selectedOptions[o]
  );
}, Re = () => {
  const e = S();
  if (!Ae().length)
    return e.variantId;
}, H = () => V().variants, J = l(void 0), x = (e) => /* @__PURE__ */ c(J.Provider, { value: e.purchaseInfo, children: e.children }), Q = l(void 0), X = (e) => /* @__PURE__ */ c(Q.Provider, { value: e.purchaseStatus, children: e.children }), _e = {
  strictVariantMatching: !1
}, Y = l(_e), ee = () => u(Y), ze = (e) => {
  const t = v(), n = S(), o = Re(), i = F(), { strictVariantMatching: s } = ee(), { selectedOptions: a } = Z(), d = H(), h = {
    sku: n.sku,
    priceInfo: n.priceInfo,
    inventory: n.inventory,
    additionalInventory: n.additionalInventory
  }, b = s ? q(d, a) !== void 0 : !0;
  let p;
  return t.discontinued && !n.inventory.inStock && i.length === 0 ? p = { status: "discontinued" } : o ? n.inventory.inStock && b ? p = {
    status: "available",
    availableItemId: o
  } : p = {
    status: "out-of-stock",
    // Default to variantId if outOfStockItemId is not set
    outOfStockItemId: n.outOfStockItemId ?? n.variantId
  } : p = {
    status: "not-determined",
    missingDimensions: i
  }, /* @__PURE__ */ c(x, { purchaseInfo: h, children: /* @__PURE__ */ c(X, { purchaseStatus: p, children: e.children }) });
}, Ue = () => {
  const e = $e(), t = We();
  return m(() => {
    if (!(!t || !e))
      return {
        ...e,
        productData: {
          ...e.productData,
          variant: t
        }
      };
  }, [e == null ? void 0 : e.productData.base.productId, t == null ? void 0 : t.variantId]);
}, $e = () => {
  try {
    return M();
  } catch {
    return;
  }
}, We = () => {
  try {
    return S();
  } catch {
    return;
  }
};
function qe(e, t) {
  const n = y(!0);
  g(() => {
    if (n.current) {
      n.current = !1;
      return;
    }
    return e();
  }, t);
}
const Fe = () => {
  const e = Ue();
  return qe(() => {
    e && E.emit("productVariantSelected", e);
  }, [
    e,
    e == null ? void 0 : e.productData.base.productId,
    e == null ? void 0 : e.productData.variant.variantId
  ]), null;
}, C = l(void 0), te = l(void 0), Ze = (e) => {
  const [t, n] = N(
    Ne,
    e.variantState
  ), o = y(!0);
  return g(() => {
    o.current ? o.current = !1 : e.variantState.variants !== t.variants && n({
      type: "SET_STATE",
      payload: e.variantState
    });
  }, [e.variantState]), /* @__PURE__ */ c(C.Provider, { value: t, children: /* @__PURE__ */ c(te.Provider, { value: n, children: /* @__PURE__ */ K(ze, { children: [
    /* @__PURE__ */ c(Fe, {}),
    e.children
  ] }) }) });
};
function He(e, t, n) {
  switch (e) {
    case "numeric": {
      const o = Number(t.label), i = Number(n.label);
      return !Number.isNaN(o) && !Number.isNaN(i) ? o - i : t.label.localeCompare(n.label);
    }
    case "alphabetical":
      return t.label.localeCompare(n.label);
  }
}
function Je(e, t) {
  const n = {};
  e.forEach((i) => {
    i.dimensions.forEach((s) => {
      const a = n[s.dimensionKey], d = (a == null ? void 0 : a.options) ?? [], h = d.find(
        (p) => p.dimensionValue === s.value
      );
      let b;
      h ? b = d.map(
        (p) => p.dimensionValue === s.value && !p.inventory.inStock ? {
          ...p,
          inventory: {
            ...p.inventory,
            inStock: i.inventory.inStock
          }
        } : p
      ) : b = [
        ...d,
        {
          dimensionValue: s.value,
          label: s.valueLabel,
          inventory: i.inventory,
          priceInfo: i.priceInfo
        }
      ], n[s.dimensionKey] = {
        dimensionKey: s.dimensionKey,
        dimensionLabel: s.dimensionLabel,
        options: b
      };
    });
  });
  const o = Object.values(n);
  return t ? o.map((i) => {
    const s = t[i.dimensionKey];
    return s ? {
      ...i,
      options: [...i.options].sort(
        (a, d) => He(s, a, d)
      )
    } : i;
  }) : o;
}
const Qe = (e) => {
  const { optionSortOrder: t } = ee(), { optionGroups: n, selectedOptions: o } = m(() => {
    const a = Je(
      e.product.variants,
      t
    ), d = Object.fromEntries(
      a.map((h) => [h.dimensionKey, void 0])
    );
    return { optionGroups: a, selectedOptions: d };
  }, [e.product.variants, t]), i = e.product.variants[0];
  if (!i)
    return console.error(
      "Product must have at least one variant, check your mapper for bugs"
    ), null;
  const s = {
    variants: e.product.variants,
    selectedVariant: i,
    initialProductVariant: i,
    selectedOptions: o,
    optionGroups: n
  };
  return /* @__PURE__ */ c(Ze, { variantState: s, children: e.children });
}, re = () => {
  const e = u(oe);
  if (!e)
    throw new Error("useBundleProduct must be used within a ProductProvider");
  return e;
}, Xe = () => re().bundlePurchaseInfo, I = () => {
  const e = u(ie);
  if (!e)
    throw new Error("useBundleState must be used within a BundleProvider");
  return e;
}, ne = l(void 0), Ye = (e) => /* @__PURE__ */ c(ne.Provider, { value: e.purchaseStatus, children: e.children }), et = ({
  children: e
}) => {
  const t = v(), n = Xe(), o = I(), i = {
    sku: n.sku,
    priceInfo: n.priceInfo,
    inventory: n.inventory,
    additionalInventory: n.additionalInventory
  }, s = Object.values(o.sections).map((h) => ({
    sectionId: h.sectionId,
    availableItemId: h.activeProduct.itemId
  })), a = s.every(
    (h) => typeof h.availableItemId == "string"
  );
  let d;
  return t.discontinued ? d = { status: "discontinued" } : n.inventory.inStock ? a ? d = {
    status: "available",
    sections: s
  } : d = {
    status: "not-determined"
  } : d = {
    status: "out-of-stock"
  }, /* @__PURE__ */ c(x, { purchaseInfo: i, children: /* @__PURE__ */ c(Ye, { purchaseStatus: d, children: e }) });
}, tt = (e, t) => {
  const n = e.sections[t.payload.sectionId];
  if (!n)
    throw new Error(`Section '${t.payload.sectionId}' not found`);
  return {
    ...e,
    sections: {
      ...e.sections,
      [t.payload.sectionId]: {
        ...n,
        activeProduct: {
          ...n.activeProduct,
          itemId: t.payload.itemId
        }
      }
    }
  };
}, rt = (e, t) => {
  const n = e.sections[t.payload.sectionId];
  if (!n)
    throw new Error(`Section '${t.payload.sectionId}' not found`);
  if (!n.products.includes(t.payload.product))
    throw new Error(
      `Product '${t.payload.product.base.content.name}' not found in section '${t.payload.sectionId}'`
    );
  return {
    ...e,
    sections: {
      ...e.sections,
      [t.payload.sectionId]: {
        ...n,
        activeProduct: {
          product: t.payload.product,
          itemId: void 0
        }
      }
    }
  };
};
function nt(e, t) {
  switch (t.type) {
    case "SELECT_SECTION_PRODUCT":
      return rt(e, t);
    case "SELECT_BUNDLE_PRODUCT_SIZE":
      return tt(e, t);
    default:
      throw new Error(`Invalid action type '${t == null ? void 0 : t.type}'`);
  }
}
const oe = l(
  void 0
), ie = l(
  void 0
), se = l(void 0), ot = ({
  children: e,
  product: t
}) => {
  const n = {};
  for (const s of t.sections) {
    const a = s.products[0];
    if (!a) {
      console.error(
        `Section '${s.sectionId}' does not have any products`
      );
      continue;
    }
    n[s.sectionId] = {
      sectionId: s.sectionId,
      products: s.products,
      activeProduct: { product: a, itemId: void 0 }
    };
  }
  const [o, i] = N(nt, {
    sections: n
  });
  return /* @__PURE__ */ c(oe.Provider, { value: t, children: /* @__PURE__ */ c(ie.Provider, { value: o, children: /* @__PURE__ */ c(se.Provider, { value: i, children: /* @__PURE__ */ c(et, { children: e }) }) }) });
}, ce = l(!1), it = (e) => /* @__PURE__ */ c(ce.Provider, { value: e.isBundle, children: e.children }), kt = () => u(ce), st = (e) => {
  const t = {
    sku: e.product.sku,
    priceInfo: e.product.priceInfo,
    inventory: e.product.inventory,
    additionalInventory: e.product.additionalInventory
  };
  let n;
  return e.product.inventory.inStock ? n = {
    status: "available",
    availableItemId: e.product.itemId
  } : e.product.base.discontinued ? n = {
    status: "discontinued"
  } : n = {
    status: "out-of-stock",
    // Default to itemId if outOfStockItemId is not set
    outOfStockItemId: e.product.outOfStockItemId ?? e.product.itemId
  }, /* @__PURE__ */ c(x, { purchaseInfo: t, children: /* @__PURE__ */ c(X, { purchaseStatus: n, children: /* @__PURE__ */ c(it, { isBundle: e.product.isBundle, children: e.children }) }) });
}, ae = l(void 0), ct = () => {
  const e = u(ae);
  if (!e)
    throw new Error(
      "useProductProviderContext must be used within a ProductProvider"
    );
  return e;
}, T = (e) => {
  const { fireOnMount: t = !1 } = e, n = M(), o = y(null), i = fe({ refElement: o });
  return g(() => {
    (t || i) && E.emit("productViewed", n);
  }, [n, t, i]), /* @__PURE__ */ K("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ c(
      "div",
      {
        ref: o,
        style: {
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          zIndex: -1
        }
      }
    ),
    e.children
  ] });
}, de = l(void 0), at = () => u(de) ?? {}, dt = r.object({
  children: r.custom(),
  strictVariantMatching: r.boolean().optional().describe(
    "Global default for strictVariantMatching. When true, prevents adding invalid size combinations to cart across all product lists and cards. Can be overridden per-component."
  ),
  optionSortOrder: r.record(r.enum(["alphabetical", "numeric"])).optional().describe(
    "Per-dimension sort strategy for option groups, keyed by dimension key (e.g. { 'waist-size': 'numeric', 'cup-size': 'alphabetical' }). Dimensions without an entry keep their original variant order."
  )
}), Vt = L(
  dt,
  ({
    children: e,
    strictVariantMatching: t,
    optionSortOrder: n
  }) => {
    const o = m(
      () => ({
        strictVariantMatching: t,
        optionSortOrder: n
      }),
      [t, n]
    );
    return /* @__PURE__ */ c(de.Provider, { value: o, children: e });
  }
), ue = l(
  void 0
), le = l(void 0), he = l(
  []
), pe = l(
  []
), ut = Ke.extend({
  product: r.custom(),
  relatedProducts: W.array().optional(),
  children: r.custom(),
  context: r.custom(),
  fireOnMount: r.boolean().optional()
}), lt = L(
  ut,
  (e) => {
    const t = at(), n = e.relatedProducts ?? [], o = m(() => {
      const a = e.product.siblingProducts ?? [];
      a.find(
        (h) => h.productId === e.product.base.productId
      ) === void 0 && a.push(e.product.base);
      const d = JSON.parse(
        JSON.stringify(a)
      );
      return d.sort((h, b) => h.productId.localeCompare(b.productId)), d;
    }, [e.product.base, e.product.siblingProducts]), i = m(
      () => ({
        strictVariantMatching: t.strictVariantMatching ?? !1,
        optionSortOrder: t.optionSortOrder
      }),
      [
        t.strictVariantMatching,
        t.optionSortOrder
      ]
    );
    let s;
    switch (e.product.dataModel) {
      case "simple":
        s = /* @__PURE__ */ c(st, { product: e.product, children: /* @__PURE__ */ c(T, { fireOnMount: e.fireOnMount, children: e.children }) });
        break;
      case "with_variants":
        s = /* @__PURE__ */ c(Qe, { product: e.product, children: /* @__PURE__ */ c(T, { fireOnMount: e.fireOnMount, children: e.children }) });
        break;
      case "bundle":
        s = /* @__PURE__ */ c(ot, { product: e.product, children: /* @__PURE__ */ c(T, { fireOnMount: e.fireOnMount, children: e.children }) });
        break;
      default:
        return console.error(
          // @ts-expect-error This is a runtime check, so we print dataModel even if TS says it doesn't exist
          `Unknown product data model: "${e.product.dataModel}", check your mapper for bugs`
        ), null;
    }
    return /* @__PURE__ */ c(Y.Provider, { value: i, children: /* @__PURE__ */ c(ae.Provider, { value: e.context, children: /* @__PURE__ */ c(le.Provider, { value: e.product.dataModel, children: /* @__PURE__ */ c(ue.Provider, { value: e.product.base, children: /* @__PURE__ */ c(he.Provider, { value: o, children: /* @__PURE__ */ c(pe.Provider, { value: n, children: s }) }) }) }) }) });
  }
);
lt.displayName = "ProductProvider";
const v = () => {
  const e = u(ue);
  if (!e)
    throw new Error("useProductBase must be used within a ProductProvider");
  return e;
}, B = () => {
  const e = u(J);
  if (!e)
    throw new Error(
      "useProductPurchaseInfo must be used within a ProductPurchaseInfoProvider"
    );
  return e;
}, M = () => {
  const e = v(), t = B(), n = ct(), { additionalData: o } = ye();
  return m(
    () => ({
      productData: {
        base: e,
        purchaseInfo: t
      },
      context: n,
      additionalData: o
    }),
    [e.productId]
  );
}, xt = (e) => {
  const t = be(), n = M(), o = y({
    ...n,
    productData: { ...n.productData, base: e.productBase }
  });
  g(() => {
    o.current = {
      ...n,
      productData: { ...n.productData, base: e.productBase }
    };
  }, [n, e.productBase]);
  const i = ve(() => {
    E.emit("productClicked", o.current), Pe.emit("close", {});
  }, []), { productBase: s, ...a } = e;
  return /* @__PURE__ */ c(
    t,
    {
      ...a,
      onClick: i,
      href: e.productBase.slug
    }
  );
}, Ct = () => {
  try {
    return v();
  } catch {
    return;
  }
}, Bt = ({
  attributes: e
}) => (t, n) => {
  if (!t || !e) {
    console.error("Attribute key is not set");
    return;
  }
  const o = e.find(
    (s) => s.attributeKey === t
  );
  if (!(typeof o > "u" || !n.safeParse(o.value).success))
    return o;
}, ht = ({
  attributes: e
}) => (t, n) => pt(e, t, n), pt = (e, t, n) => {
  if (!t) {
    console.error("Attribute key is not set");
    return;
  }
  const o = e.find(
    (s) => s.attributeKey === t
  );
  if (!(typeof o > "u" || !n.safeParse(o.value).success))
    return o;
}, Mt = (e, t) => {
  const n = v();
  return ht(n)(e, t);
}, jt = () => {
  const e = u(le);
  if (!e)
    throw new Error(
      "useProductDataModel must be used within a ProductProvider"
    );
  return e;
}, Kt = () => V().optionGroups.some(
  (t) => t.options.some((n) => n.inventory.inStock)
), bt = (e, t) => e.filter((n) => {
  var i;
  const o = (i = n.attributes) == null ? void 0 : i.find(
    (s) => s.attributeKey === t.key
  );
  return t.value.includes(o == null ? void 0 : o.value);
}), Nt = (e) => {
  const {
    content: { media: t }
  } = v(), n = t.filter(Te), o = e == null ? void 0 : e.attributeFilter;
  return o === void 0 ? n : bt(
    n,
    o
  );
}, Lt = () => B().inventory, Gt = () => H().some((t) => t.inventory.inStock), At = () => B().priceInfo, Rt = () => {
  const e = u(Q);
  if (!e)
    throw new Error(
      "useProductPurchaseStatus must be used within a ProductPurchaseStatusProvider"
    );
  return e;
}, _t = () => {
  const e = u(he);
  if (!e)
    throw new Error("useProductSiblings must be used within a ProductProvider");
  return e;
}, zt = (e) => {
  var n;
  return (n = v().content.specifications) == null ? void 0 : n[e];
}, Ut = (e) => {
  const t = u(pe);
  if (!t)
    throw new Error("useRelatedProducts must be used within a ProductProvider");
  return e ? t.filter(
    (n) => n.relationType === e
  ) : t;
}, mt = () => {
  const e = u(se);
  if (!e)
    throw new Error("useBundleDispatch must be used within a BundleProvider");
  return e;
}, $t = () => re().itemId, Wt = () => {
  const e = I(), t = mt(), n = (i, s) => {
    t({
      type: "SELECT_BUNDLE_PRODUCT_SIZE",
      payload: {
        sectionId: i,
        itemId: s
      }
    });
  }, o = (i, s) => {
    t({
      type: "SELECT_SECTION_PRODUCT",
      payload: {
        sectionId: i,
        product: s
      }
    });
  };
  return {
    sections: e.sections,
    selectSectionSize: n,
    selectSectionProduct: o
  };
}, qt = () => {
  const e = u(ne);
  if (!e)
    throw new Error(
      "useBundlePurchaseStatus must be used within a BundlePurchaseStatusProvider"
    );
  return e;
}, vt = (e) => {
  const { sections: t } = I(), n = t[e];
  if (!n)
    throw new Error(`Section '${e}' not found`);
  return n.activeProduct.product;
}, Ft = (e) => {
  const { sections: t } = I(), n = vt(e), o = t[e];
  if (!o)
    throw new Error(`Section '${e}' not found`);
  return o.products.filter((i) => i !== n);
}, Zt = r.object({
  siblings: P.array().describe("The sibling products"),
  selectedSibling: P.describe("The selected sibling product")
}), Ht = r.object({
  label: r.string(),
  value: r.string(),
  icon: r.custom(() => !0).optional()
}), ft = r.object({
  label: r.string().describe("The label of the option, like 'Red' or 'Small'"),
  dimensionValue: r.string().describe("The value of the dimension, used when doing add to cart"),
  inventory: w,
  priceInfo: _.describe(
    "The price information for this option, useful in case of a price change depending on a selected option, like different materials"
  )
}), Jt = r.object({
  dimensionKey: r.string().describe("The dimension key"),
  dimensionLabel: r.string().describe("The dimension label"),
  options: r.array(ft)
});
export {
  ot as BundleProductProvider,
  Ye as BundlePurchaseStatusProvider,
  Vt as GlobalProductSettingsProvider,
  it as IsBundleProvider,
  et as ProductBundlePurchaseProvider,
  Dt as ProductEventAdditionalDataProvider,
  xt as ProductLink,
  lt as ProductProvider,
  x as ProductPurchaseInfoProvider,
  X as ProductPurchaseStatusProvider,
  st as ProductSimpleProvider,
  Fe as ProductVariantEventDispatcher,
  Ze as ProductVariantProvider,
  ze as ProductVariantPurchaseProvider,
  T as ProductViewedEvent,
  Qe as ProductWithVariantsProvider,
  O as attributeSchema,
  se as bundleDispatchContext,
  oe as bundleProductContext,
  Me as bundlePurchaseInfoSchema,
  ne as bundlePurchaseStatusContext,
  nt as bundleReducer,
  ie as bundleStateContext,
  bt as filterMediaOnAttributeValues,
  pt as getProductAttribute,
  q as getVariantFromOptions,
  ce as isBundleContext,
  Te as isProductMediaImage,
  Ve as previouslyDiscountedPriceSchema,
  R as priceInfoSchema,
  we as productBadgeSchema,
  ue as productBaseContext,
  P as productBaseSchema,
  je as productBundleSchema,
  Be as productBundleSectionSchema,
  Oe as productCategorySchema,
  Ee as productContentSchema,
  le as productDataModelContext,
  E as productEventEmitter,
  A as productMediaDimensionsSchema,
  ge as productMediaImageSchema,
  Ie as productMediaSchema,
  Se as productMediaVideoSchema,
  Jt as productOptionGroupSchema,
  ft as productOptionSchema,
  ae as productProviderContextContext,
  ut as productProviderSchema,
  J as productPurchaseInfoContext,
  k as productPurchaseInfoSchema,
  w as productPurchaseInventorySchema,
  ke as productPurchasePriceDiscountSchema,
  _ as productPurchasePriceSchema,
  Q as productPurchaseStatusContext,
  pe as productRelatedProductsContext,
  $ as productSchema,
  Y as productSettingsContext,
  D as productSharedSchema,
  he as productSiblingProductsContext,
  De as productSiblingSchema,
  Zt as productSiblingsSchema,
  z as productSimpleSchema,
  Ht as productSpecificationSchema,
  xe as productVariantDimensionSchema,
  te as productVariantDispatchContext,
  Ne as productVariantReducer,
  Ce as productVariantSchema,
  C as productVariantStateContext,
  Ke as productViewModelSchema,
  U as productWithVariantsSchema,
  W as relatedProductSchema,
  tt as selectBundleProductSize,
  rt as selectSectionProduct,
  mt as useBundleDispatch,
  $t as useBundleItemId,
  Wt as useBundleOptions,
  re as useBundleProduct,
  Xe as useBundlePurchaseInfo,
  qt as useBundlePurchaseStatus,
  vt as useBundleSectionActiveProduct,
  Ft as useBundleSectionProductAlternatives,
  I as useBundleState,
  at as useGlobalProductSettings,
  kt as useIsBundle,
  Ct as useMaybeProductBase,
  Bt as useMediaAttributeGetter,
  Mt as useProductAttribute,
  ht as useProductAttributeGetter,
  v as useProductBase,
  jt as useProductDataModel,
  ye as useProductEventAdditionalData,
  M as useProductEventData,
  Kt as useProductHasOptionsInStock,
  Nt as useProductImages,
  Lt as useProductInventory,
  Gt as useProductIsInStock,
  Z as useProductOptions,
  At as useProductPriceInfo,
  ct as useProductProviderContext,
  B as useProductPurchaseInfo,
  Rt as useProductPurchaseStatus,
  ee as useProductSettings,
  _t as useProductSiblings,
  zt as useProductSpecificationGroup,
  S as useProductVariant,
  F as useProductVariantDimensions,
  Le as useProductVariantDispatch,
  Ue as useProductVariantEventData,
  V as useProductVariantState,
  H as useProductVariants,
  Ut as useRelatedProducts,
  Re as useSelectedVariantId,
  Ae as useVariantMissingDimensions,
  Je as variantsToProductOptionGroups
};
